/* assets/mp-sidebar-autoload.js — Herstellerseiten-Ausbau, Revision 1 (2026-07-14)
 * Fallback trigger for the desktop static sidebar (permanent-spinner bug fix).
 *
 * Root cause (confirmed via section-render probing, not guesswork): the
 * "sidebar-collection" section instance on the 5 brand collection templates
 * shipped with "disabled": true in the template JSON. A disabled static
 * section renders NONE of its liquid output — not even the hidden
 * <template> wrapper or the `data-sidebar-id` trigger button in
 * sections/sidebar-collection.liquid. Theme JS (T4SThemeSP.sideBarInit in
 * assets/interactable.min.js) looks up `[data-sidebar-id]` on every page
 * load; when that element doesn't exist (t.length == 0) the function's
 * whole body is skipped, so the `[data-sidebar-content]` aside (rendered
 * unconditionally by sections/main-collection.liquid, with its default
 * `<div class="t4s-loading--bg">` spinner placeholder) never gets filled.
 * The 5 templates have since been re-enabled (disabled flag removed), which
 * is the real fix. This script is kept as a defensive fallback only: if a
 * future template/section edit reintroduces a disabled or slow-to-init
 * sidebar, or if an unrelated JS error earlier in the theme's shared
 * `$(document).ready()` chain aborts before it reaches
 * `T4SThemeSP.sideBarInit()` (that handler is one big comma-expression —
 * one throw anywhere upstream silently skips everything after it), desktop
 * visitors still get a populated sidebar instead of a permanent spinner.
 * Mobile is untouched (gated to >=1025px, matches the CSS breakpoint in
 * mp-filter-sidebar.css that force-displays the aside and hides the drawer
 * trigger).
 */
(function () {
  function desktopViewport() {
    // 2026-07-20 (Sale-Seiten-Spinner-Fix): die frühere Sichtbarkeitsprüfung
    // (getComputedStyle(aside).display !== 'none') funktioniert nicht mehr,
    // seit mp-filter-sidebar.css den UNGEFUELLTEN Platzhalter bewusst
    // versteckt (:has-Regel gegen den Dauer-Spinner) — sie wäre vor dem
    // Füllen immer false. Stattdessen direkt der CSS-Breakpoint.
    try { return window.matchMedia('(min-width: 1025px)').matches; }
    catch (e) { return (window.innerWidth || 0) >= 1025; }
  }

  function stillLoading(aside) {
    if (aside.querySelector('.t4s-loading--bg')) return true;
    if (aside.children.length === 0) return true;
    /* ⚠ 16.09.2026: Kindknoten zaehlen reicht nicht. Auf Sammlungen ohne Filter
       (z. B. Badschraenke) enthaelt die Spalte ein <link> und ein .t4s-sidebar-inner
       mit einer LEEREN .t4s-row — formal drei Knoten, sichtbar nichts. Entschieden
       wird deshalb ueber die tatsaechlich gerenderte Hoehe. */
    var innen = aside.querySelector('.t4s-sidebar-inner');
    if (!innen) return true;
    try { if (innen.getBoundingClientRect().height < 10) return true; } catch (e) {}
    return false;
  }

  /* Bleibt die Filterspalte leer, soll das Produktraster die volle Breite nehmen.
     Bisher haing das an einer handgepflegten Liste von Sammlungen in
     mp-brand-toolbar.css — jede neue Sammlung fing sich die leere Spalte neu ein. */
  function breiteAusgleichen() {
    var aside = document.querySelector('aside[data-sidebar-content]');
    var haupt = document.querySelector('.t4s-main-collection-page');
    if (!aside || !haupt) return;
    var leer = stillLoading(aside);
    haupt.classList.toggle('mp-voll', leer);
    aside.classList.toggle('mp-leer', leer);
  }

  // Fallback fuer Browser ohne :has()-Support: sobald der Sidebar-Inhalt da
  // ist, Klasse setzen, an der die display-Regel in mp-filter-sidebar.css
  // zusaetzlich haengt. In :has()-Browsern redundant, aber harmlos.
  function watchFilled() {
    var aside = document.querySelector('aside[data-sidebar-content]');
    if (!aside) return;
    breiteAusgleichen();
    if (!stillLoading(aside)) { aside.classList.add('mp-sidebar-filled'); return; }
    var mo = new MutationObserver(function () {
      if (!stillLoading(aside)) {
        aside.classList.add('mp-sidebar-filled');
        breiteAusgleichen();
        mo.disconnect();
      }
    });
    mo.observe(aside, { childList: true, subtree: true });
  }

  try {
    window.addEventListener('resize', function () { clearTimeout(window.__mpBreiteT); window.__mpBreiteT = setTimeout(breiteAusgleichen, 200); });
  } catch (e) {}

  function tryFillSidebar(attemptsLeft) {
    var aside = document.querySelector('aside[data-sidebar-content]');
    if (!aside || !desktopViewport()) return;
    if (!stillLoading(aside)) return; // theme JS already filled it — nothing to do

    if (window.T4SThemeSP && typeof window.T4SThemeSP.sideBarInit === 'function') {
      try {
        window.T4SThemeSP.sideBarInit();
      } catch (e) {
        if (window.console) console.error('[mp-sidebar-autoload] sideBarInit() threw', e);
      }
      return;
    }
    if (attemptsLeft > 0) {
      setTimeout(function () {
        tryFillSidebar(attemptsLeft - 1);
      }, 200);
    }
  }

  function arm() {
    watchFilled();
    // give the theme's own ready-handler chain a moment to run first so we
    // don't double-fetch on the normal/working path
    setTimeout(function () {
      tryFillSidebar(15);
    }, 400);
  }
  // window 'load' may already have fired by the time this script executes
  // (script sits at the end of theme.liquid) — a late listener would then
  // never fire. Check readyState first.
  if (document.readyState === 'complete') { arm(); }
  else { window.addEventListener('load', arm); }
})();
